module.exports = __webpack_public_path__ + "static/loremipsum-d281699be87cb56ffe27d417bd97c682.png";